import React, { useEffect, useState } from 'react'
import {  verDocumentoDerivacion } from '../../utils/Datos';


export const BotonDocumento = ({documento}) => {

    const [content, setcontent] = useState({contentByte:'',contentType:'',name:''});

    useEffect(() => {

        //verDocumentoDerivacion(documento.id_doc_derivation).then((respuesta)=>{
        verDocumentoDerivacion(documento.id_document_response).then((respuesta)=>{
        if (respuesta.status) {
            setcontent(respuesta.datos);
        }
      })
    }, [documento])

    const base64toBlob = (data) => {
        const bytes = atob(data);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
          out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: "application/pdf" });
      };

    const blob = base64toBlob(content.contentByte);
    const url = URL.createObjectURL(blob);

    const handleFileDownload=()=>{
        if (content!=null) {
            const base64toBlob = (data) => {
                const bytes = atob(data);
                let length = bytes.length;
                let out = new Uint8Array(length);

                while (length--) {
                  out[length] = bytes.charCodeAt(length);
                }

                return new Blob([out], { type: content.contentType });
              };

            const blob = base64toBlob(content.contentByte);
            const url = URL.createObjectURL(blob);

             // Crear un elemento "a" para descargar el archivo
             const a = document.createElement('a');
             a.href = url;
             a.download = content.name;

             // Simular un clic en el elemento "a" para iniciar la descarga
             a.click();
             URL.revokeObjectURL(url);
        }

    }

    let iconClass='fa-file-pdf';
    switch (documento.extension_doc) {
        case 'pdf':
            iconClass='fa-file-pdf text-danger';
        break;

        case 'xls':
        case 'xlsx':
            iconClass='fa-file-excel text-success';
        break;

        case 'doc':
        case 'docx':
            iconClass='fa-file-word text-blue';
        break;

        case 'png':
        case 'gif':
        case 'jpeg':
        case 'jpg':
            iconClass='fa-file-image text-success';
        break;

        default:
            iconClass='fa-file';
        break;
    }

    return (
        content != null ?
        <button
            onClick={handleFileDownload}
            className="p-4 btn btn-secondary btn-lg btn-block mb-3">
            <i className={`fa-solid ${iconClass} fa-4x`}></i>
            <span className="fs-6"> {documento.name_doc}</span>
        </button> :
        <button
            disabled
            className="p-4 btn btn-secondary btn-lg btn-block mb-3">
            <i className={`fa-solid ${iconClass} fa-4x`}></i>
            <span className="fs-6"> {documento.name_doc} (no existe el archivo)</span>
        </button>

    )
}
